/**
 * IntelliGems A/B Test 3 — Free shipping indicator (native cart drawer)
 *
 * Control: data-free-shipping-indicator="false"
 * Variant: data-free-shipping-indicator="true"
 * Dev: ?free_shipping_indicator_test=b
 */
(function () {
  'use strict';

  if (window.__freeShippingIndicatorABTestInit) return;
  window.__freeShippingIndicatorABTestInit = true;

  var BODY_ATTR = 'data-free-shipping-indicator';
  var ROOT_ATTR = 'data-free-shipping-indicator-root';
  var debounceTimer = null;

  function isTruthy(value) {
    var n = String(value || '')
      .trim()
      .toLowerCase();
    return n === 'true' || n === '1' || n === 'on' || n === 'yes';
  }

  function isDevVariantB() {
    try {
      return (
        new URLSearchParams(window.location.search).get(
          'free_shipping_indicator_test'
        ) === 'b'
      );
    } catch (e) {
      return false;
    }
  }

  function isVariantB() {
    if (isDevVariantB()) return true;
    var body = document.body;
    return !!(body && isTruthy(body.getAttribute(BODY_ATTR)));
  }

  function applyDev() {
    if (!isDevVariantB() || !document.body) return;
    if (!isTruthy(document.body.getAttribute(BODY_ATTR))) {
      document.body.setAttribute(BODY_ATTR, 'true');
    }
  }

  function updateRoot(root, cart) {
    if (!root) return;
    var items =
      cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var total =
      cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var threshold = parseInt(root.getAttribute('data-threshold'), 10) || 0;
    var show = items > 0;
    var earned = threshold <= 0 || total >= threshold;
    var percent = 100;

    if (threshold > 0) {
      percent = Math.max(
        0,
        Math.min(100, Math.round((total / threshold) * 100))
      );
    }

    root.setAttribute('data-has-items', show ? 'true' : 'false');
    root.setAttribute('data-total', String(total));
    root.setAttribute('aria-valuenow', String(percent));
    root.classList.toggle('free-shipping-indicator-ab--earned', earned);

    var fill = root.querySelector('[data-free-shipping-indicator-fill]');
    if (fill) fill.style.width = percent + '%';

    var label = root.querySelector('[data-free-shipping-indicator-label]');
    if (label) {
      label.innerHTML = earned
        ? 'You have earned <strong>free shipping</strong>.'
        : 'Spend more to get <strong>free shipping</strong>.';
    }
  }

  function syncNativeProgressVisibility() {
    var hide = isVariantB();
    document.querySelectorAll('.cart-progress, .cart-checkpoints').forEach(function (el) {
      if (hide) {
        el.setAttribute('data-fs-indicator-hidden', 'true');
        el.style.display = 'none';
      } else if (el.getAttribute('data-fs-indicator-hidden') === 'true') {
        el.removeAttribute('data-fs-indicator-hidden');
        el.style.display = '';
      }
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  function apply() {
    applyDev();
    syncNativeProgressVisibility();
    if (!isVariantB()) return;

    var roots = document.querySelectorAll('[' + ROOT_ATTR + ']');
    if (!roots.length) return;

    fetchCart().then(function (cart) {
      if (!cart) return;
      roots.forEach(function (root) {
        updateRoot(root, cart);
      });
    });
  }

  function scheduleApply() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(apply, 80);
  }

  function boot() {
    apply();

    if (document.body && window.MutationObserver) {
      new MutationObserver(scheduleApply).observe(document.body, {
        attributes: true,
        attributeFilter: [BODY_ATTR, 'class'],
      });
    }

    document.addEventListener('cart:updated', scheduleApply);
    document.addEventListener('cart:refresh', scheduleApply);

    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(scheduleApply).observe(drawer, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.ComfofeetFreeShippingIndicator = { apply: apply, isVariantB: isVariantB };
})();
